/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CommentDotsIcon = /*#__PURE__*/ createSvgIcon(
  'CommentDotsIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.983 1.5h8.034l.017.001a2.65 2.65 0 012.465 2.465l.001.017v5.084l-.001.017a2.65 2.65 0 01-2.465 2.465l-.017.001H6.21l-2.468 2.525c-.372.4-.934.511-1.408.324-.502-.199-.834-.695-.834-1.349V3.983l.001-.017a2.65 2.65 0 012.465-2.465l.017-.001zm.035 1A1.65 1.65 0 002.5 4.018v9.032c0 .296.128.39.201.419a.282.282 0 00.311-.077l.005-.006L5.79 10.55h6.192A1.65 1.65 0 0013.5 9.032V4.018A1.65 1.65 0 0011.982 2.5H4.018z"
            fill="currentColor"
          />
          <path
            d="M10.7 7.36a.9.9 0 100-1.8.9.9 0 000 1.8zM5.3 7.36a.9.9 0 100-1.8.9.9 0 000 1.8zM8 7.36a.9.9 0 100-1.8.9.9 0 000 1.8z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.929 2.495a2.15 2.15 0 00-2.434 2.434l.005.035V17c0 .224.055.346.103.411a.336.336 0 00.203.127c.197.046.48-.024.68-.212L6.77 13.5h8.266l.035.005a2.15 2.15 0 002.434-2.434l-.005-.035V4.964l.005-.035a2.15 2.15 0 00-2.434-2.434l-.035.005H4.964l-.035-.005zm.105-.995A3.15 3.15 0 001.5 5.034V17c0 .391.099.736.3 1.008.204.273.484.435.779.504.568.133 1.202-.073 1.622-.486l.015-.014L7.23 14.5h7.736a3.15 3.15 0 003.534-3.534V5.034A3.15 3.15 0 0014.966 1.5H5.034z"
            fill="currentColor"
          />
          <path
            d="M13.6 9.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zM6.4 9.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zM10 9.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            d="M16.5 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM7.5 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.818 2.499a3.13 3.13 0 00-3.32 3.346l.002.017V20.53l-.003.029a.84.84 0 001.447.671l3.987-4.309H18.18a3.14 3.14 0 003.32-3.32V5.862l.001-.017a3.13 3.13 0 00-3.32-3.346l-.015.001H5.834l-.016-.001zm.047-.999A4.13 4.13 0 001.5 5.897v14.576a1.84 1.84 0 003.175 1.438l.002-.001 3.692-3.99h9.767a4.14 4.14 0 004.364-4.364V5.897A4.13 4.13 0 0018.135 1.5H5.865z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CommentDotsIcon;
